import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import useAuth from "../../hooks/useAuth";
import NewsBell from "../productNews/NewsBell";
import { isCommerceRole } from "../productNews/commerceMenu";

// El comercio (cliente y gestor de comercio) ve en la campana las novedades de
// la plataforma (components/productNews), con contador real de no leídas.
export default function NotificationsBell() {
  const { user } = useAuth();
  return isCommerceRole(user?.role) ? <NewsBell /> : <EmptyNotificationsBell />;
}

// Campana del resto de los roles — UI lista, SIN backend todavía.
// El front viejo no tiene notificaciones; cuando el back las exponga, cablear acá:
//   - `unread` con la cuenta real de no-leídas (mostrará el badge),
//   - reemplazar el estado vacío por la lista.
function EmptyNotificationsBell() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const unread = 0; // TODO: cablear a notificaciones reales cuando existan en el back

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} className="header-notif">
      <DropdownToggle
        tag="button"
        caret={false}
        className="header-icon-btn"
        aria-label={`${t("Notificaciones")}${unread > 0 ? ` (${unread} sin leer)` : ""}`}
        title={t("Notificaciones")}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          notifications
        </span>
        {unread > 0 && (
          <span className="header-notif__badge">{unread > 9 ? "9+" : unread}</span>
        )}
      </DropdownToggle>

      <DropdownMenu end className="header-notif__menu">
        <div className="header-notif__header">{t("Notificaciones")}</div>
        <div className="header-notif__empty">
          <span className="material-symbols-outlined" aria-hidden="true">
            notifications_off
          </span>
          <p>{t("No tienes notificaciones")}</p>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}
